import Vue from 'vue'
import Vuex from 'vuex'
import session from './modules/session'
import sessionExpiresTime from './modules/sessionExpiresTime'
import locale from './modules/locale'
import claims from './modules/claims'
import snackbar from './modules/snackbar'
import mainMenu from './modules/mainMenu'
import company from './modules/company'
import globalLoader from './modules/globalLoader'
import globalDrawer from './modules/globalDrawer'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    session,
    sessionExpiresTime,
    locale,
    claims,
    snackbar,
    mainMenu,
    company,
    globalLoader,
    globalDrawer
  }
})
